import Vue from 'vue'
import Vuex from 'vuex'

import process from './modules/process'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    process
  }
})
